export default {
  getMarketData: async function() {
    return fetch("https://bleachlondon.com/markets/read", {
      headers: {
        "X-App-Origin": window.location.origin
      }
    }).then(response => {
      return response.json()
    })
  }
}
